import { z, ZodType } from 'zod';
import { CustomErrorParams, CustomErrorType, DateTimeUtcService, dateTimeUtcStringSchema } from '@mews/framework';
import { AccountingExportIntegrationExportRequest } from '@mews-commander/data-access';
import { FieldNames } from '../fieldNames';

export const accountingExportFormSchema = z
    .object({
        [FieldNames.startDate]: dateTimeUtcStringSchema.default(''),
        [FieldNames.endDate]: dateTimeUtcStringSchema.default(''),
    })
    .superRefine((value, ctx) => {
        const startDate = DateTimeUtcService.parse(value.startDate);
        const endDate = DateTimeUtcService.parse(value.endDate);

        if (DateTimeUtcService.isGreater(startDate, endDate)) {
            ctx.addIssue({
                path: [FieldNames.startDate],
                code: z.ZodIssueCode.custom,
                params: { errorType: CustomErrorType.DateString } satisfies CustomErrorParams,
                fatal: true,
            });
            return z.NEVER;
        }

        return value;
    }) satisfies ZodType<AccountingExportIntegrationExportRequest>;

export type AccountingExportFormSchema = z.infer<ZodType<AccountingExportIntegrationExportRequest>>;
